import { useLayoutEffect } from "react";
import { useData } from "data/data-provider";
import { useLocation, useNavigationType } from "react-router-dom";
import DesignARouter from "routers/DesignARouter";
import DesignBRouter from "routers/DesignBRouter";

function App() {
  const { loadingCompanyDetails, ourCompany } = useData();
  const location = useLocation();
  const navigationType = useNavigationType();

  // Layout effect so the history is updated before child useEffects (e.g.
  // BackRouteButton) read it on the same location change.
  useLayoutEffect(() => {
    const historyKey = "app_route_history";
    const currentPath = location.pathname + location.search;
    let history: string[] = [];

    try {
      const rawHistory = sessionStorage.getItem(historyKey);
      history = rawHistory ? (JSON.parse(rawHistory) as string[]) : [];
    } catch {
      history = [];
    }

    if (navigationType === "POP") {
      // Back/forward (or first load). Mirror the browser back stack by
      // dropping entries above the current path instead of re-appending —
      // otherwise BackRouteButton reads the page we just left as "previous".
      while (history.length && history[history.length - 1] !== currentPath) {
        history.pop();
      }
      if (history.length === 0) {
        history.push(currentPath);
      }
    } else if (navigationType === "REPLACE") {
      if (history.length) {
        history[history.length - 1] = currentPath;
      } else {
        history.push(currentPath);
      }
    } else if (history[history.length - 1] !== currentPath) {
      history.push(currentPath);
    }

    sessionStorage.setItem(historyKey, JSON.stringify(history.slice(-30)));
  }, [location.pathname, location.search, navigationType]);

  return (
    <div className="bg-bg-color">
      {loadingCompanyDetails ? (
        <div className="flex justify-center items-center col-span-full min-h-[100vh]">
          <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
        </div>
      ) : (
        // <div className="text-base text-text-color bg-bg-color">
        //   {ourCompany?.default_template === "design2" ? (
        //     <DesignBRouter />
        //   ) : (
        <DesignARouter />
        //   )}
        // </div>
      )}
    </div>
  );
}

export default App;
